import React, { Fragment, useEffect, useState } from "react";
import UserService from "../../../services/UserService";
import { NavLink, useLocation } from "react-router-dom";
//Components
import Panel from "../../../components/Panel";
import ProgramEditor from "../../Develop/Program/ProgramEditor";
import Accordion from "../../../components/Accordion/Accordion";
import ActionButton from "../../../components/Buttons/ActionButton";
//Sockets
import { useDevice, useProgram } from "../../../Api/newSockets.api";
// Icons
import { ReactComponent as SettingsIcon } from "../../../assets/icons/settings.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as ConsoleIcon } from "../../../assets/icons/console.svg";
import { ReactComponent as PowerIcon } from "../../../assets/icons/power.svg";
import { ReactComponent as ArrowDownIcon } from "../../../assets/icons/arrow_down.svg";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play.svg";

import DeviceMenu from "./DeviceMenu";
import DevicesHeader from "../../../components/Header/DevicesHeader";
import { savePathToLocalStorage } from "../../../utils/helpers";
import Table from "../../../components/Table/Table";

type Props = {
  device: any;
  label: string;
  icon: any;
  match: any;
};

const Program = (props: Props) => {
  savePathToLocalStorage();
  const headers = [
    {
      label: "Name",
      key: "name",
      type: "text",
    },
    {
      label: "Date Created",
      key: "dateCreated",
      type: "date",
    },
    {
      label: "Date Modified",
      key: "dateModified",
      type: "date",
    },
  ];

  const actions = () => {
    return (
      <>
        <ActionButton icon={<PlayIcon />} onClick={() => handleClick} />
      </>
    );
  };

  const handleClick = () => {
    console.log("handle click");
  };

  const deviceId = props.match.params.deviceId;
  // Get program
  const { getProgram, getProgramsByDeviceGroup, connected } = useProgram();

  // Get device
  const { getDevice } = useDevice();
  const { device } = getDevice(parseInt(deviceId));

  const [programsByDeviceGroup, setProgramsByDeviceGroup] = useState<any>();

  useEffect(() => {
    if (!connected || !device) return;
    getProgramsByDeviceGroup(device.groupId)
      .then((response) => setProgramsByDeviceGroup(response))
      .catch(() => setProgramsByDeviceGroup(undefined));
  }, [connected, device]);
  return (
    <div className="device-main main-content">
      <DevicesHeader device={device} />
      <div
        className="program-body-content"
        style={{ display: "flex", flexDirection: "row" }}
      >
        {device && device.deviceTypes && (
          <div>
            <DeviceMenu typeId={device.deviceTypes.id} />
          </div>
        )}
        <div
          className="device-program"
        >
          {device && programsByDeviceGroup && programsByDeviceGroup.length > 0 && (
            <Fragment>
              {/* TODO: Currently passing first program id, dynamic only active/deployed program */}
              <ProgramEditor
                programId={programsByDeviceGroup[0].id}
                readMode={true}
                classNameWrapper={"devices-element-wrapper"}
              />
              <Table
                tableName={"Previous actions"}
                headers={headers}
                actions={actions}
                items={programsByDeviceGroup}
              />
            </Fragment>
          )}

          {/* {device && (
            <Accordion title={`Program: ${program && program.name}`} expanded>
              <p>Description: {program && program.desc}</p>
              <p>Device Group: {program && program.deviceGroups?.name}</p>
              <ProgramEditor programId={device.programId} readMode={true} />
            </Accordion>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default Program;
